/**
 * Whether this browser can stand up a WebGL context at all.
 *
 * jsdom — the environment every `vitest` test runs under — implements neither
 * `webgl2` nor `webgl`, so a test that does not mock this module exercises the
 * real "3D can't run here" path rather than a stand-in for it. That is
 * deliberate: it is the cheapest possible test of the floor map's own failure
 * mode for the 3D view, and it costs nothing to keep passing.
 *
 * Cached after the first call — context creation is not free, and the answer
 * does not change while the tab is open.
 */
let cached: boolean | null = null;

export function supportsWebgl(): boolean {
  if (cached !== null) return cached;
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2') ?? canvas.getContext('webgl');
    cached = !!gl;
  } catch {
    cached = false;
  }
  return cached;
}

/** Test-only — forces the next `supportsWebgl()` call to probe again. */
export function resetWebglSupportCache(): void {
  cached = null;
}
